import React from "react";
import "./loader.css";
import { ThreeCircles } from "react-loader-spinner";

const Loader = () => {
  return (
    <div className="loader">
      <ThreeCircles
        height="100"
        width="100"
        color="#06c491"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor=""
        innerCircleColor=""
        middleCircleColor=""
      />
    </div>
  );
};

export default Loader;